import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { useContext, useEffect, useMemo, useState } from "react";
import { BacktestingRunType } from "@shared/types";
import {
  useGetBacktestingRuns,
  useGetBacktestingRunsArgs,
} from "@shared/features/bots/BotForm/Backtesting/hooks";

interface UseBacktestingHistoryProps {
  queryAppliedBacktesting?: number;
  unapplyConfiguration?: () => void;
}

const useBacktestingHistory = ({
  queryAppliedBacktesting,
  unapplyConfiguration,
}: UseBacktestingHistoryProps) => {
  const { botType } = useContext(BotFormContext)!;
  const args = useGetBacktestingRunsArgs();

  const [backtestingToDelete, setBacktestingToDelete] =
    useState<BacktestingRunType>();

  const { data, isFetching, isUninitialized } = useGetBacktestingRuns(args);
  const appliedBacktesting = useMemo(() => {
    if (!queryAppliedBacktesting) return undefined;
    return data?.find(
      (backtesting) => backtesting.id === queryAppliedBacktesting
    );
  }, [data, queryAppliedBacktesting]);

  useEffect(() => {
    if (data && queryAppliedBacktesting && !appliedBacktesting) {
      unapplyConfiguration?.();
    }
  }, [data]);

  const backtestingRuns = useMemo(
    () =>
      data
        ?.filter(
          (backtestingRun) => backtestingRun.id !== appliedBacktesting?.id
        )
        .slice()
        .sort((a, b) => (b?.created_at || 0) - (a?.created_at || 0)),
    [data, appliedBacktesting]
  );
  const showEmptyState =
    !appliedBacktesting && !backtestingRuns?.length && !isUninitialized;
  const showDivider = !!appliedBacktesting && !!backtestingRuns?.length;

  return {
    isFetching,
    backtestingRuns,
    showEmptyState,
    backtestingToDelete,
    setBacktestingToDelete,
    appliedBacktesting,
    showDivider,
    botType,
  };
};

export default useBacktestingHistory;
